<div class="m-2 row flex justify-center" *ngIf="(serviceChannels$ | async).length !== 0; else noServiceChannels">
    <div class="col-md-10 row">
      <div class="col-md-6" *ngFor="let serviceChannel of (serviceChannels$ | async); let i = index">
        <div class="p-3 bg-white rounded-md m-1">
          <div class="col-md-12 d-flex flex-column move-left">
            <div class="text-bold text-primary-500">{{ 'service_delivery_channel_title' | translate }}</div>
            {{serviceChannel?.channelName}}
          </div>
          <div class="col-md-12 flex justify-end">
            
          </div>
        </div>
      </div>
  
    </div>
  </div>
  
  <ng-template #noServiceChannels>
    <div class="bg-white col-md-10 mt-4 mx-auto rounded-md p-4 text-center font-medium text-muted move-left">
      {{ 'no_service_channel' | translate }}
    </div>
  </ng-template>
